import React, {useState, useEffect} from 'react'
import './single.scss'
import Sidebar from '../../../components/sidebar/Sidebar'
import Navbar from '../../../components/navbar/Navbar'
// import Chart from '../../../components/chart/Chart'
// import SalesTable from '../../../components/table/SalesTable'
import { useParams } from 'react-router-dom'
import { doc, getDoc, updateDoc, onSnapshot, collection, query, orderBy, addDoc, serverTimestamp, deleteField } from "firebase/firestore"
import { auth, db, storage } from '../../../firebase'
import ApplicationTable from '../../../components/table/ApplicationTable'
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import { ref, uploadBytesResumable, getDownloadURL, deleteObject } from "firebase/storage";
import { useNavigate } from "react-router-dom"
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ApplicationTableTravelInfo from '../../../components/table/ApplicationTableTravelInfo'
import ApplicationTableMaritalInfo from '../../../components/table/ApplicationTableMaritalInfo'
import ApplicationTableParentInfo from '../../../components/table/ApplicationTableParentInfo'
import ApplicationTableEducationInfo from '../../../components/table/ApplicationTableEducationInfo'
import ApplicationTableEmploymentInfo from '../../../components/table/ApplicationTableEmploymentInfo'
import ApplicationTableTravelHistoryInfo from '../../../components/table/ApplicationTableTravelHistory'
import ApplicationTableDocumentsInfo from '../../../components/table/ApplicationTableDocumentsInfo'
import ApplicationTablePaymentInfo from '../../../components/table/ApplicationTablePaymentInfo'
import ApplicationTableManageDocument from '../../../components/table/ApplicationTableManageDocument'

const Single = () => {

  const {applicationId} = useParams()

  const navigate = useNavigate();

  const [file, setFile ] = useState("")

  const [applicant, setApplicant] = useState()

  const [ data, setData ] = useState({})
  const [ perc, setPerc ] = useState(null)

  const [ applicationData, setapplicationData ] = useState([])
  // const [ shopping, setShopping ] = useState([])
  const [ statusUpdate, setStatusUpdate ] = useState("")
  const [ selectQuery, setSelectQuery ] = useState([])
  const [ openModal, setOpenModal ] = useState(false)
  // const [ driverData, setDriverData ] = useState([])
  const [ driverDetails, setDriverDetails ] = useState()
  const [ selectedDriver, setSelectedDriver ] = useState('')
  const [validDocument, setValidDocument] = useState("")
  const [fileError, setFileError] = useState("")

  const [interviewDateError, setInterviewDateError] = useState("")

  const [interviewDate, setInterviewDate] = useState(new Date());

  const closeModal = () => setOpenModal(false)



  useEffect(() => {

    const uploadFile = () => {

      const name = new Date().getTime() + file.name;
      
      const storageRef = ref(storage, name);

      const uploadTask = uploadBytesResumable(storageRef, file);


      uploadTask.on('state_changed', 
        (snapshot) => {
        
          const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          console.log('Upload is ' + progress + '% done');
          setPerc(progress)
          switch (snapshot.state) {
            case 'paused':
              console.log('Upload is paused');
              break;
            case 'running':
              console.log('Upload is running');
              break;
            default:
              break;
          }
        }, 
        (error) => {
          console.log(error)
        }, 
        () => {
         
          getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
            // setValidDocument((prev) => ({...prev, downloadURL}))
            setValidDocument(downloadURL)
          });
        }
      );

    };

    file && uploadFile();

  }, [file]);
  
  

  const getVisa = async() => {

      const docRef = doc(db, "visa", applicationId);

      const docSnap = await getDoc(docRef);

          
      if (docSnap.exists()) {

        setapplicationData({...docSnap.data(), children: docSnap.data().children} )

      } else {
        
        console.log("No such document!");
      }


  }

  

   console.log(applicationData)

   console.log('image: ',validDocument)

   

  useEffect(()=>{

    getVisa()

  }, [])

  console.log('APPLICATION: ',applicationData)





    const acceptMsg = async() => {

      try {
  
        const docRef = await addDoc(collection(db, "messages"), 
        
        {
  
          message : "Your visa application has been accepted, its now under processing .",
  
          firstname : applicationData.firstname,
  
          surname : applicationData.surname,
  
          userId : applicationData.userId,
  
          iconName : "document-outline",
  
          status : "unread",
  
          timeStamp: serverTimestamp(),
  
        }
      
      )   
      }catch(error){
  
        console.log(error)
  
      }
  
    }   
      
    

 const acceptVisa = async() => {
      
  const acceptRef = doc(db, "visa", applicationId);

     const updateStatus = updateDoc(acceptRef, {
      status: "PROCESSING"
    });

    acceptMsg()

    

    const thisStatus = updateStatus.status
    console.log(thisStatus)
        

 }


  // PROCESSING VISA


  const processingMsg = async() => {

    try {

      const docRef = await addDoc(collection(db, "messages"), 
      
      {

        message : "We are compiling and processing all required information for your visa approval.",

        firstname : applicationData.firstname,

        surname : applicationData.surname,

        userId : applicationData.userId,

        iconName : "briefcase-outline",

        status : "unread",

        timeStamp: serverTimestamp(),

      }
    
    )   
    }catch(error){

      console.log(error)

    }

  }

  

    const processingVisa = async(e) => {

      e.preventDefault()

      if(!validDocument){

          return setFileError("You must upload visa document")
          
      }

       if(interviewDate === ""){

        return setInterviewDateError("You must upload visa document")
        
       }

      try{

         const acceptRef = doc(db, "visa", applicationId);
    
         await updateDoc(acceptRef, {

          visaDocument : validDocument,

          interviewDate : interviewDate,

          status: "DELIVERING"



        });

        processingMsg()

        setValidDocument("")

        setInterviewDateError("")

        setFileError("")

        closeModal()

      }catch (err) {

            console.log(err);

      } 

    }


    const deleteImage = async() => {

      const deleteRef = ref(storage, validDocument);
  
          // Delete the file
      deleteObject(deleteRef).then(async() => {
  
  
          const visaRef = doc(db, 'visa', applicationId);
  
          await updateDoc(visaRef, {
  
            visaDocument: deleteField(),
            
          });
  
          
          alert("Document deleted successfully")
  
          setValidDocument("")

          setFile("")
          // navigation.navigate("CacDocumentImageScreen")
  
      }).catch((error) => {
          // Uh-oh, an error occurred!
          console.log(error)
      });
  
    }

    // DECLINE 

    const declineMsg = async() => {

      try {
  
        const docRef = await addDoc(collection(db, "messages"), 
        
        {

          message : "your visa application has been declined.",

          firstname : applicationData.firstname,

          surname : applicationData.surname,

          userId : applicationData.userId,

          iconName : "chevron-down",

          status : "unread",

          timeStamp: serverTimestamp(),

        }
      
      )   
      }catch(error){

        console.log(error)

      }

    }
      

          const declineVisa = async() => {
      
            const acceptRef = doc(db, "visa", applicationId);
          
              const updateStatus = await updateDoc(acceptRef, {

                status: "DECLINED"

              });

              declineMsg()
          
           
          }

          // APPROVED 


          const approveMsg = async() => {

            try {
        
              const docRef = await addDoc(collection(db, "messages"), 
              
              {
      
                message : "your visa application has been approved, printout your document for your visa interview.",
      
                firstname : applicationData.firstname,
      
                surname : applicationData.surname,
      
                userId : applicationData.userId,
      
                iconName : "send-outline",
      
                status : "unread",
      
                timeStamp: serverTimestamp(),
      
              }
            
            )   
            }catch(error){
      
              console.log(error)
      
            }
      
          }  



          const completeVisa = async() => {
      
            const acceptRef = doc(db, "visa", applicationId);
          
              const updateStatus = await updateDoc(acceptRef, {

                status: "APPROVED"

              });

              approveMsg()
          
           
          }


    // QUERY FOR THE VISA

    const getVisaStatus = async() => {

      onSnapshot(doc(db, "visa", applicationId), (doc) => {
      console.log("Current visa: ", doc.data());
      setStatusUpdate(doc.data());
      console.log(statusUpdate);
      console.log(statusUpdate.status)
      const newStatus = statusUpdate.status
      console.log(newStatus)

    });

   
    
    }

    const newStatus = statusUpdate.status 

    useEffect(()=>{
      getVisaStatus()
    }, [])



      //LISTEN REAL TIME
   
      
   

  const Modal = ({open, close}) => {
     
     if(!open) return null
     return(
      <div className='overlay'>
        <div className="modalContainer">
        
          <div className="modalRight">
            <p className="closeBtn" onClick={close}>X</p>
            <div className="content">
              {/* <p className="head">Applicant Document for Visa Interview should be uploaded</p> */}
              <h3 className="driver">Upload <span>{applicationData.country}</span> Visa Document for <span>{applicationData.firstname} {applicationData.surname}</span></h3>

            </div>

            {fileError &&

              <div style={{color:'red', alignItems:'center', display:'flex', justifyContent:'center'}}>{fileError}</div>
            
            }
           

            <div className='formContainer'>

              <div className="left">

          

     
              </div>

              <form onSubmit={(e) => { e.preventDefault(); processingVisa(e); }}>


                {
                    validDocument !== "" && file !== ""

                    &&  

                    
                    <div className='camerawrap'>

                      <img
                        src="../images/doc.png" alt="pic"
                      /> 
                  
                      <button type="button" onClick={() => deleteImage()}>

                        <img
                          src="../images/remove.png" alt="pic" className='remove'
                        /> 

                      </button>

                    </div>


                }


                
                {
                    validDocument === "" && file !== ""

                    &&  

                    

                      <h3 style={{color:'green'}}>{perc}</h3>



                }

                {

                  validDocument === "" && file === "" &&

                  <div className='formInput formAlign'>
                  <label style={{marginRight:20}} htmlFor='file'>Document:</label>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', alignItems: 'flex-start' }}>
                {/* Hidden default file input */}
                <input  
                  type="file"  
                  id="file"  
                  className='input' 
                  accept=".jpg, .jpeg, .png, .pdf, .doc"  
                  onChange={e => setFile(e.target.files[0])}  
                  style={{ display: 'none' }} 
                />

                {/* Styled label acting as the button */}
                <label 
                  htmlFor="file" 
                  style={{
                    backgroundColor: '#007bff', // Change this to your desired color
                    color: 'white',
                    padding: '10px 20px',
                    borderRadius: '5px',
                    cursor: 'pointer',
                    display: 'inline-block',
                    fontWeight: 'bold'
                  }}
                >
                  Choose File
                </label>

                {/* Conditionally display the file name */}
                {file && (
                  <span style={{ fontSize: '14px', color: '#333' }}>
                    Selected file: <strong>{file.name}</strong>
                  </span>
                )}
              </div>
                  
                </div>

                }

                <div className='formInput formDate'>
                  <label>Interview Date:</label>
                  <DatePicker 
                    selected={interviewDate} 
                    onChange={(date) => setInterviewDate(date)} 
                  />
                </div>

                {/* FIXED: Standardized to check and display the correct error */}
                {interviewDateError && (
                  <div style={{ color: 'red', alignItems: 'center', display: 'flex', justifyContent: 'center' }}>
                    {interviewDateError}
                  </div>
                )}

                <div className="btnContainer">
                  {/* FIXED: Added type="button" to prevent form submission */}
                  <button type="button" className="btnoutline" onClick={close}>
                    <span className="bold">No</span>, Cancel
                  </button>
                  <button type="submit"  className="btnprimary">
                    <span className='bold'>Yes</span>, Continue
                  </button>
                </div>

              </form>


            {/* <form  onSubmit={processingVisa}>

                    <div className='formInput formAlign'>
                      <label htmlFor='file'>
                        Document:
                      </label>
                      <input type="file" id="file" accept=".jpg, .jpeg, .png, .pdf, .doc" onChange= {e => setFile(e.target.files[0])}/>
                    </div>

                    <div className='formInput formDate'>
                       
                      <label>Interview Date:</label>

                      <DatePicker selected={interviewDate} onChange={(date) => setInterviewDate(date)}/>

                      
                    </div>

                    {fileError &&

                      <div style={{color:'red', alignItems:'center', display:'flex', justifyContent:'center'}}>{interviewDateError}</div>

                      }
               
             
                      <div className="btnContainer">

                        <button className="btnoutline" onClick={close}>
                          <span className="bold">No</span>, Cancel
                        </button>
                        <button className="btnprimary" type='submit' >
                          <span className='bold'>Yes</span>,Continue
                        </button>

                      </div>

               </form>
 */}

            </div>
           
          </div>
        </div>
      </div>
     )
}


  return (
    <div className='single'>
      <Sidebar/>
      <div className='singleContainer'>
        <Navbar/>
        <div className='topTitle'>

        <div className='topLeft'><h4>Visa Application ID - {applicationData.biometricID}</h4></div>
          
          <div className='topRight'>
          <Breadcrumbs aria-label="breadcrumb">
            <Link underline="hover" color="inherit" href="/">
              Home
            </Link>
            <Link
              underline="hover"
              color="inherit"
              href="/applications"
            >
              Application List
            </Link>
            <Typography color="green">Visa Application Details</Typography>
          </Breadcrumbs>
          </div>
        </div>

        <div className="bottom">
            <h3>Manage {applicationData.surname}  {applicationData.firstname} Visa Status</h3>

            {newStatus === 'APPROVED'
            
            ?

            <div className='completedContainer'>
              <div className='completedWrapper'>
                  <button className= 'completed' disabled> This Visa has been Approved Successfully!!!</button>
              </div>
              
            </div>

            :

            <div>
                 <div className='buttonTop'>

                  {newStatus === 'RECEIVED'

                  ?     <div>
                          <button className= 'buttonAccept' onClick={acceptVisa}>ACCEPT APPLICATION</button>
                        </div>

                  :     <div>
                          <button className= 'received' disabled onClick={acceptVisa}>ACCEPT APPLICATION</button>
                        </div>

                  }


                  <div>
                    <button className='buttonDecline' onClick={declineVisa}>DECLINE APPLICATION</button>
                  </div>

                  </div>

                  {((newStatus === 'PROCESSING') || (newStatus === 'DELIVERING') || (newStatus === 'DELIVERED')) &&

                  <div className='buttonBottom'>

                  { ((newStatus === 'PROCESSING') || (newStatus === 'DELIVERING') || (newStatus === 'DELIVERED') )

                    ?   
                                                
                        <div>
                          {/* <button className='processing' onClick={processingVisa}>PROCESSING VISA APPLICATION</button> */}
                          <button className='processing' onClick={() => setOpenModal(true)}>PROCESSING VISA DOCUMENT</button> 
                          <Modal open={openModal} close={closeModal}/>
                        </div>

                    :   <div>
                          <button className= 'received' disabled onClick={processingVisa}>PROCESSING VISA APPLICATION</button>
                        </div>

                  }


                  { ((newStatus === 'DELIVERING') || (newStatus === 'DELIVERED'))

                    ?   <div>
                            <hr className='lines-processing'/>
                        </div>

                    :   <div>
                            <hr className='lines-disabledProcessing'/>
                        </div>

                  }


                  { ((newStatus === 'DELIVERING') || (newStatus === 'DELIVERED'))

                  ?   <div>
                        <button onClick={() => alert("Applicant must Confirm Delivery First")} className='delivering' >DELIVERING DOCUMENT</button>
                      </div>

                  :   <div>
                        <button className= 'disableDelivering' disabled >DELIVERING DOCUMENT</button>
                      </div>

                  }


                  { (newStatus === 'DELIVERED')

                  ?   <div>
                          <hr className='lines-delivering'/>
                      </div>

                  :   <div>
                          <hr className='lines-disabledDelivering'/>
                      </div>

                  }


                  { (newStatus === 'DELIVERED') 

                  ?   <div>
                        <button className='delivered' onClick={completeVisa}>DELIVERED DOCUMENT</button>
                      </div>

                  :   <div>
                        <button className= 'disabledDelivered' disabled >APPLICANT WILL CONFIRM DELIVERY</button>
                      </div>

                  }



                  </div>
                  }
            </div>
            
            }

           
         
        </div>

        {/* Top 1 */}
       
        <div className="top">

          <div className="left">
            
            <div className='item'>
               
                <div className="details">
                  <h3 className='itemTitle'>{applicationData.firstname} {applicationData.surname}</h3>
                  <div className='detailItem'>
                    <span className='itemKey'>Gender:</span>
                    <span className='itemValue'>{applicationData.gender}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Phone:</span>
                    <span className='itemValue'>{applicationData.phoneNumber}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Address:</span>
                    <span className='itemValue'>{applicationData.address}</span>
                  </div>
              
                </div>
            </div>
          </div>

          <div className='middle'>
          
            <div className='listTitle'><h3>Travel Info</h3></div>
              <ApplicationTableTravelInfo
                applicationData= {applicationData}
              />
              
            </div>

          <div className='right'>
          
            <div className='listTitle'><h3>Marital Info</h3></div>
              <ApplicationTableMaritalInfo
                applicationData= {applicationData} children={applicationData.children}
              />
              
            </div> 
        </div>

        <div className="top">

        <div className='left'>
          
          <div className='listTitle'><h3>Parent Info</h3></div>
            <ApplicationTableParentInfo
              applicationData= {applicationData}
            />
            
          </div>

          <div className='middle'>
          
          <div className='listTitle'><h3>Education Info</h3></div>
            <ApplicationTableEducationInfo
              applicationData= {applicationData}
            />
            
          </div>

          <div className='right'>
          
            <div className='listTitle'><h3>Employment Info</h3></div>
              <ApplicationTableEmploymentInfo
                applicationData= {applicationData}
              />
              
            </div> 
        </div>

        <div className="top">

        <div className='left'>
          
          <div className='listTitle'><h3>Travel History</h3></div>
            <ApplicationTableTravelHistoryInfo
              applicationData= {applicationData}
            />
            
          </div>

          <div className='middle'>
          
          <div className='listTitle'><h3>Payment</h3></div>
           
             <ApplicationTablePaymentInfo
                applicationData= {applicationData}
              />
            
          </div>

          <div className='right'>
          
            <div className='listTitle'><h3>Documents</h3></div>
              <ApplicationTableDocumentsInfo
                applicationData= {applicationData}
              />
              
            </div> 
        </div>


        <div className="bottom">

        <div className='listTitle'><h2>Manage Documents</h2></div>

              <ApplicationTableManageDocument
                // applicationData= {applicationData}
                applicationId={applicationId}
              />
         
        </div>
       
        </div>
       
      </div>
  )
}

export default Single